import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule, FormBuilder, FormArray, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { AccordionModule } from 'primeng/accordion';
import { CalendarModule } from 'primeng/calendar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { AddInstituteService } from '../../../../services/super-admin/add-institute.service';
import { Mastersrequest, Mastersresponse } from '../../../../models/Institutedetails/Mastersrequest';
import { apiResponse } from '../../../../models/apiResponse';
import { scrollToFirstInvalidControl } from '../../../../direct-apply/shared/validators/form-validation.utils';

@Component({
    selector: 'app-masters-doctoral',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextModule,
        DropdownModule,
        InputTextareaModule,
        InputNumberModule,
        AccordionModule,
        CalendarModule,
        InputSwitchModule
    ],
    templateUrl: './masters-doctoral.component.html',
    styleUrls: ['./masters-doctoral.component.scss']
})
export class MastersDoctoralComponent implements OnInit, OnChanges {
    @Input() form!: FormGroup;
    @Input() instituteId: string | null = null;
    @Input() isEditMode: boolean = false;
    @Output() onSaveSuccess = new EventEmitter<any>();
    @Output() onSaveError = new EventEmitter<any>();
    private mastersId: number = 0;
     private detailsLoaded = false;
    currency = [
        { label: 'USD', value: 0 },
        { label: 'INR', value: 1 },
        { label: 'EUR', value: 2 },
        { label: 'GBP', value: 3 }
    ];

    constructor(
        private fb: FormBuilder,
        private addInstituteService: AddInstituteService
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['instituteId'] && this.instituteId && this.isEditMode && !this.detailsLoaded) {
            this.detailsLoaded = true;  
            this.loadMastersDetails();
        }
    }

    ngOnInit() {
        if (this.form) {
            const numberPattern = '^[0-9.%-]*$';
            const percentPattern = '^(100|[1-9]?[0-9])(\\.[0-9]{1,2})?%?$';
            const alphanumericPattern = /^[a-zA-Z0-9\s,.-@/#()]*$/;
            const alphaPattern = /^[a-zA-Z\s()]*$/;

            this.form.addControl('applicationFees', this.fb.control(''));
            this.form.addControl('currency', this.fb.control(0));
            this.form.addControl('englishLanguageRequirement', this.fb.control(''));

            this.form.addControl('tuitionFees', this.fb.control(''));
            this.form.addControl('housingCapacity', this.fb.control(''));
            this.form.addControl('combinedFoodHousingCharge', this.fb.control(''));
            this.form.addControl('medianFamilyIncome', this.fb.control(''));

            this.form.addControl('graduateStudentsEnrolled', this.fb.control(''));
            this.form.addControl('partTimeEnrollment', this.fb.control(''));
            this.form.addControl('internationalGraduateStudents', this.fb.control(''));
            this.form.addControl('fullTimeIndianPostGraduateStudents', this.fb.control(''));
            this.form.addControl('maleGraduateEnrollment', this.fb.control(''));
            this.form.addControl('femaleGraduateEnrollment', this.fb.control(''));

            this.form.addControl('malePercentage', this.fb.control(''));
            this.form.addControl('femalePercentage', this.fb.control(''));
            this.form.addControl('americanIndianPercentage', this.fb.control(''));
            this.form.addControl('asianPercentage', this.fb.control(''));
            this.form.addControl('blackPercentage', this.fb.control(''));
            this.form.addControl('hispanicPercentage', this.fb.control(''));
            this.form.addControl('nativeHawaiianPercentage', this.fb.control(''));
            this.form.addControl('whitePercentage', this.fb.control(''));
            this.form.addControl('twoOrMoreRacesPercentage', this.fb.control(''));
            this.form.addControl('raceUnknownPercentage', this.fb.control(''));

            this.form.addControl('graduateAssistantTotal', this.fb.control(''));
            this.form.addControl('teachingAssistants', this.fb.control(''));
            this.form.addControl('researchAssistants', this.fb.control(''));
            this.form.addControl('phdPrograms', this.fb.control(''));
            this.form.addControl('MastersPrograms', this.fb.control(''));
            this.form.addControl('faculty', this.fb.control('',));
            this.form.addControl('totalDepartments', this.fb.control(''));
            this.form.addControl('totalEnrollment', this.fb.control(''));
            this.form.addControl('scholarships', this.fb.control(''));

            this.form.addControl('additionalNotes', this.fb.control(''));

            this.form.addControl('uk', this.fb.control(''));
            this.form.addControl('eu', this.fb.control(''));
            this.form.addControl('postGraduate', this.fb.control(''));
            this.form.addControl('underGraduate', this.fb.control(''));

            if (!this.form.contains('id')) {
                this.form.addControl('id', this.fb.control(0));
            } else {
                this.mastersId = this.form.get('id')?.value || 0;
            }

             if (this.isEditMode && this.instituteId && !this.detailsLoaded) {  
                this.detailsLoaded = true;
                this.loadMastersDetails();
            }
        }
    }

    private loadMastersDetails() {
        if (this.instituteId) {
            this.addInstituteService.getMastersDetails(this.instituteId).subscribe({
                next: (response: apiResponse<Mastersresponse>) => {
                    const data = response.result || response as any;
                    if (data) {
                        this.mastersId = data.id;
                        this.form.get('id')?.setValue(data.id);
                        this.form.patchValue({
                            applicationFees: data.applicationFees,
                            currency: data.currency,
                            englishLanguageRequirement: data.englishLanguageRequirement,
                            tuitionFees: data.tutionFees,
                            housingCapacity: data.housingCapacity,
                            combinedFoodHousingCharge: data.combinedFoodAndHousingCharge,
                            medianFamilyIncome: data.medianFamilyIncome,
                            graduateStudentsEnrolled: data.graduateStudentsEnrolled,
                            partTimeEnrollment: data.partTimeEnrollment,
                            internationalGraduateStudents: data.internationalStudents,
                            malePercentage: data.maleEnrollment,
                            femalePercentage: data.femaleEnrollment,
                            fullTimeIndianPostGraduateStudents: data.fullTimeIndianPostGraduateStudents,
                            maleGraduateEnrollment: data.maleGraduateEnrollment,
                            femaleGraduateEnrollment: data.femaleGraduateEnrollment,

                            americanIndianPercentage: data.americanIndianOrAlaskaNative,
                            asianPercentage: data.asian,
                            blackPercentage: data.blackOrAfricanAmerican,
                            hispanicPercentage: data.hispanicOrLatino,
                            nativeHawaiianPercentage: data.nativeHawaiianOrOtherPacificIslander,
                            whitePercentage: data.white,
                            twoOrMoreRacesPercentage: data.twoOrMoreRaces,
                            raceUnknownPercentage: data.raceOrEthnicityUnknown,

                            graduateAssistantTotal: data.graduateAssistantTotal,
                            teachingAssistants: data.graduateAssistantsTeaching,
                            researchAssistants: data.graduateAssistantsResearch,

                            phdPrograms: data.numberOfCoursesOffersPhd,
                            MastersPrograms: data.numberOfCoursesOffersMasters,
                            faculty: data.faculty,
                            totalDepartments: data.totalDepartments,
                            totalEnrollment: data.totalEnrollment,
                            scholarships: (data.scholarships && data.scholarships.length) ? data.scholarships.join('\n') : '',

                            additionalNotes: data.others,
                            uk: data.uk || '',
                            eu: data.eu || '',
                            postGraduate: data.postGraduate || '',
                            underGraduate: data.underGraduate || ''
                        });
                    }
                },
                error: (err: any) => this.onSaveError.emit(err)
            });
        }
    }

    private formatDate(date: any): string {
        if (!date) return '';
        try {
            const dates = new Date(date);
            if (isNaN(dates.getTime())) return '';
            const year = dates.getFullYear();
            const month = String(dates.getMonth() + 1).padStart(2, '0');
            const day = String(dates.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        } catch {
            return '';
        }
    }

    save() {
        if (this.form.valid) {
            if (!this.instituteId) {
                this.onSaveError.emit({ message: 'Institute ID is missing. Please save Basic Information first.' });
                return;
            }
            const formValue = this.form.value;

            const request: Mastersrequest = {
                instituteId: String(this.instituteId || ''),
                applicationFees: formValue.applicationFees || '',
                currency: Number(formValue.currency ?? 0),
                englishLanguageRequirement: formValue.englishLanguageRequirement || '',
                tutionFees: formValue.tuitionFees || '',
                housingCapacity: parseInt(formValue.housingCapacity) || 0,
                combinedFoodAndHousingCharge: parseInt(formValue.combinedFoodHousingCharge) || 0,
                medianFamilyIncome: formValue.medianFamilyIncome || '',
                graduateStudentsEnrolled: parseInt(formValue.graduateStudentsEnrolled) || 0,
                partTimeEnrollment: parseInt(formValue.partTimeEnrollment) || 0,
                internationalStudents: formValue.internationalGraduateStudents || '',

                maleEnrollment: formValue.malePercentage || '',
                femaleEnrollment: formValue.femalePercentage || '',
                americanIndianOrAlaskaNative: formValue.americanIndianPercentage || '',
                asian: formValue.asianPercentage || '',
                blackOrAfricanAmerican: formValue.blackPercentage || '',
                hispanicOrLatino: formValue.hispanicPercentage || '',
                nativeHawaiianOrOtherPacificIslander: formValue.nativeHawaiianPercentage || '',
                white: formValue.whitePercentage || '',
                twoOrMoreRaces: formValue.twoOrMoreRacesPercentage || '',
                raceOrEthnicityUnknown: formValue.raceUnknownPercentage || '',

                graduateAssistantTotal: parseInt(formValue.graduateAssistantTotal) || 0,
                graduateAssistantsTeaching: parseInt(formValue.teachingAssistants) || 0,
                graduateAssistantsResearch: parseInt(formValue.researchAssistants) || 0,

                numberOfCoursesOffersPhd: parseInt(formValue.phdPrograms) || 0,
                numberOfCoursesOffersMasters: parseInt(formValue.MastersPrograms) || 0,
                faculty: formValue.faculty || '',
                totalDepartments: formValue.totalDepartments || '',
                totalEnrollment: formValue.totalEnrollment || '',
                scholarships: formValue.scholarships
                    ? String(formValue.scholarships).split('\n').map((s: string) => s.trim()).filter((s: string) => s.length > 0)
                    : [],

                fullTimeIndianPostGraduateStudents: formValue.fullTimeIndianPostGraduateStudents || '',
                maleGraduateEnrollment: formValue.maleGraduateEnrollment || '',
                femaleGraduateEnrollment: formValue.femaleGraduateEnrollment || '',

                others: formValue.additionalNotes || '',
                uk: formValue.uk || '',
                eu: formValue.eu || '',
                postGraduate: formValue.postGraduate || '',
                underGraduate: formValue.underGraduate || ''
            };

            if (this.mastersId > 0) {
                request.id = this.mastersId;
            }

            const apiCall = this.mastersId > 0
                ? this.addInstituteService.updateMastersDetails(request)
                : this.addInstituteService.mastersDetails(request);

            apiCall.subscribe({
                next: (res: any) => {
                    const savedId = res.result?.Id || res.result?.id || res.result?.instituteId || res.id;
                    if (savedId) {
                        this.mastersId = Number(savedId);
                        this.form.get('id')?.setValue(this.mastersId);
                    }
                    this.onSaveSuccess.emit({ mode: this.mastersId > 0 ? 'edit' : 'add', response: res });
                },
                error: (err: any) => {
                    this.onSaveError.emit(err);
                }
            });
        } else {
            this.markFormGroupTouched(this.form);
            scrollToFirstInvalidControl();
            const invalidFields = this.getInvalidFields();
            this.onSaveError.emit({ validationError: true, fields: invalidFields });
        }
    }

    private getInvalidFields(): string[] {
        const invalid: string[] = [];
        const controls = this.form.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                const label = name
                    .replace(/([A-Z])/g, ' $1')
                    .replace(/^./, (str) => str.toUpperCase());
                invalid.push(label);
            }
        }
        return invalid;
    }

    private markFormGroupTouched(formGroup: FormGroup | FormArray) {
        Object.values(formGroup.controls).forEach(control => {
            if (control instanceof FormGroup || control instanceof FormArray) {
                this.markFormGroupTouched(control);
            } else {
                control.markAsTouched();
                control.markAsDirty();
            }
        });
    }
}
